import React, { Component, Fragment, useEffect, useCallback, useState, useRef } from 'react';
import './style.css';
import { Layout, Menu, Select, Breadcrumb, Spin, Button, Space, Form, Input, Row, Col, Divider, TimePicker } from 'antd';
import { MinusCircleOutlined, PlusOutlined, SearchOutlined, MoreOutlined, SyncOutlined } from '@ant-design/icons';
import Container from '../Layout/Container';
import { Wizard, Steps, Step } from 'react-albus';
import { Link, useHistory, useLocation, Redirect } from "react-router-dom";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { editTemplate, getApptAsyn, getDepartmentInfoAsyn, clearState, clearStateSuccess, editTemplateSelector, getTemplateInfoAsyn } from './editTemplateDraftSlice'
import MaskedInput from 'antd-mask-input'
import moment from 'moment';
import { authSelector } from '../Auth/authSlice';
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

export default function EditTemplateDraft() {
  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();
  const [pending, setPending] = useState(false)
  const [isToast, setToast] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [branchval, setBranchVal] = React.useState("");
  const [directorateval, setDirectorateVal] = React.useState("");
  const [directoratesOption, setDirectorates] = React.useState([]);
  const [state, setState] = useState({})

  const [processDetails, setProcessDetails] = useState({})
  const [stageDetails, setStageDetails] = useState([])

  const [stagesValue, setStageValue] = useState([])

  const formRef = useRef(null);
  const formStageRef = useRef(null);
  let apptOptions = null;

  const { isFetching, isSuccess, isError, errorMessage, roles, departmentInfo, isAddTemplateSuccess, templateInfo } = useSelector(
    editTemplateSelector
  );

  const { user } = useSelector(
    authSelector
  );

  //const templateId = localStorage.getItem('templateIddraft')?localStorage.getItem('templateIddraft'):location.state.templateId;
  const templateId = location.state.templateId;

  useEffect(() => {
    // setToast(true);
    setLoading(true);
    dispatch(clearState());
    if (location.state.templateId) {
      localStorage.setItem('templateIddraft', location.state.templateId);
      let templateId = localStorage.getItem('templateIddraft');
      dispatch(getTemplateInfoAsyn(templateId));
    }
    else {
      let templateId = localStorage.getItem('templateIddraft');
      dispatch(getTemplateInfoAsyn(templateId));
    }

    // let templateId = localStorage.getItem('templateIddraft');

    // dispatch(getTemplateInfoAsyn(templateId));
    dispatch(getDepartmentInfoAsyn())
  }, []);




  useEffect(() => {
    if (isSuccess) {
      setToast(false);
      // setLoading(false);
      dispatch(clearStateSuccess());
      if (templateInfo.stage && templateInfo.stage.length) {
        templateInfo.stage.map((st, i) => {
          if (st.users && st.users.length) {
            st.users.map((su, j) => {
              setUsers(st.departmentTypeName, i, st.departmentType, i);
            })
          }
        })
      }

      setTimeout(() => {
        if (formRef.current) {
          formRef.current.setFieldsValue({
            processName: templateInfo.processName,
            processSubject: templateInfo.processSubject
          });
        }


        let stages = [];
        //  console.log('templateInfo.stage')
        //  console.log(templateInfo.stage)
        if (templateInfo.stage && templateInfo.stage.length) {
          templateInfo.stage.map((st, i) => {
            let suser = [];
            if (st.users && st.users.length) {

              // setUsers(st.departmentTypeName,i,st.departmentTypeName,i);

              st.users.map((su, j) => {
                let d = su.responseTime.day;
                if (d.toString().length == 1) {
                  d = "0" + d;
                }
                let t = su.responseTime.time;
                let rstime = d + ':' + t;
                // console.log(rstime)
                //setUsers(st.departmentTypeName,i,st.departmentTypeName,j);
                let u = { username: su.username ? '{"label":"' + su.username.name + '","value":"' + su.username.username + '"}' : ' ', responseTime: rstime, stage_uuid: su.stage_uuid, template_uuid: su.template_uuid, uuid: su.uuid };
                suser.push(u);
              })
            }

            let s = { departmentType: st.departmentType ? st.departmentType : ' ', departmentTypeName: st.departmentTypeName ? st.departmentTypeName : ' ', directorateWithinBranch: st.directorateWithinBranch ? st.directorateWithinBranch : '', users: suser, template_uuid: st.template_uuid, uuid: st.uuid }
            stages.push(s);
          })
        }
        else {
          stages.push({ departmentType: ' ', departmentTypeName: ' ', directorateWithinBranch: '', users: [{ username: ' ', responseTime: '' }] });
        }
        setStageValue(stages);
        if (formStageRef.current) {
          formStageRef.current.setFieldsValue({
            stage: stages
          });
        }
        setLoading(false);
      }, 1000);
      setLoading(false);
    }

    if (isAddTemplateSuccess) {
      dispatch(clearStateSuccess());
      setLoading(false);
      setToast(true);
      toast.success('Seen Stamp created successfully');
      history.push('/manage-seen-stamp');

    }

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);

    }

  }, [isError, isSuccess, isAddTemplateSuccess, setLoading, setToast]);


  useEffect(() => {

  }, [state]);


  const setUsers = async (v, k, dt, name) => {
    // console.log('v=' + v + ' k=' + k + ' dt=' + dt)
    setDepartmentTypeEmpty(k);
    // const fields = formStageRef.current.getFieldsValue();
    // const {stage} = fields
    //  Object.assign(stage[k].users, {username: ''})
    // formStageRef.current.setFieldsValue({stage})
    // let options = getAppt(v,dt,k);
    // console.log(options)
    // console.log(stage[k].users)
    // Object.assign(stage[k].users, {username: options})
    // formStageRef.current.setFieldsValue({stage})
    if (formStageRef.current) {
      formStageRef.current.setFieldsValue({ username: undefined });
    }

    //userlist
    let uData = await getAllAppts(v, dt);

    let Options = [];
    if (uData && uData.data && uData.data.length > 0) {
      uData.data.map((val, index) => {
        let valObjStr = JSON.stringify({ label: val.name, value: val.username });
        Options.push({ label: val.name, value: valObjStr })
        // Options.push({label:val.name,value:val.username})
      })
    }

    let uname = 'userlist__dep_' + name;
    setState(prev => ({
      ...prev,
      [uname]: Options
    }));

    // state['userlist_'+key
    // console.log(Options)
    // const fields = formStageRef.current.getFieldsValue();
    // const {stage} = fields
    //  Object.assign(stage[k], {username: ''})
    // // formStageRef.current.setFieldsValue({stage})
    // Object.assign(stage[k], {userlist: Options,allusername:Options})
    // formStageRef.current.setFieldsValue({stage})


    // formStageRef.current.setFieldsValue({stage})
    // //const value = formStageRef.current.getFieldValue()

    // //const value =  formStageRef.current.getFieldValue('userlist');
    // console.log(stage[k])
    // formStageRef.setFieldsValue({'users': {...value, ['userlist']: Options}})
  }

  const getAllAppts = async (dtype, department) => {
    let code = 'b';
    switch (department) {
      case 'Branch': {
        code = 'b';
        break;
      }
      case 'Independent Office': {
        code = 'io'
        break;
      }
      case 'Independent Directorate': {
        code = 'id'
        break;
      }
      default:
        code = 'b';
    }

    let response = await fetch(process.env.REACT_APP_API_URL + "/api/template/getAppt?department=Chief of Air Staff&code=" + code + "&departmentTypeName=" + dtype, {
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.token
      }
    });

    let data = await response.json()
    // console.log(data)
    return data;

  }

  const setDepartmentTypeEmpty = (k) => {
    if (formStageRef.current) {
      const fields = formStageRef.current.getFieldsValue();
      const { stage } = fields
      // Object.assign(stage[k], {departmentTypeName: '',directorateWithinBranch:''})
      Object.assign(stage[k], { directorateWithinBranch: '' })
      formStageRef.current.setFieldsValue({ stage })
    }

  }

  const getBranches = () => {
    const branchOptions = [];
    if (departmentInfo && departmentInfo.branch_data && departmentInfo.branch_data.length > 0) {
      departmentInfo.branch_data.map((val, index) => {
        branchOptions.push({ value: val.b_name })
      })
    }
    return branchOptions;
  }

  // function getDirectorate(value) {
  //   setDirectorateVal('');
  //   let totalBranches = [];
  //   let totalDirectorates = [];
  //   if(departmentInfo && departmentInfo.branch_data && departmentInfo.branch_data.length > 0){
  //     departmentInfo.branch_data.map((val,index) => {
  //       totalBranches.push(val)
  //     })
  //   }

  //   if(totalBranches.length > 0){
  //     let dir = totalBranches.filter(br => br.b_name==value).map((dr) => {
  //        return dr.bd_directorates;
  //     });

  //     if(dir && dir[0].length > 0){
  //       dir[0].map((val,index) => {
  //         totalDirectorates.push({value:val.bd_name})
  //       });
  //       setDirectorates(totalDirectorates);
  //     }
  //   }
  // }

  function getDirectorate(value) {
    let totalBranches = [];
    let totalDirectorates = [];
    if (departmentInfo && departmentInfo.branch_data && departmentInfo.branch_data.length > 0) {
      departmentInfo.branch_data.map((val, index) => {
        totalBranches.push(val)
      })
    }

    if (totalBranches.length > 0) {
      let dir = totalBranches.filter(br => br.b_name == value).map((dr) => {
        return dr.bd_directorates;
      });
      //console.log(dir)
      if (dir && dir[0] && dir[0].length > 0) {
        dir[0].map((val, index) => {
          totalDirectorates.push({ value: val.bd_name })
        });

      }
    }
    return totalDirectorates;
  }

  const getIndependentOffices = () => {
    const Options = [];
    if (departmentInfo && departmentInfo.io_independentOffices && departmentInfo.io_independentOffices.length > 0) {
      departmentInfo.io_independentOffices.map((val, index) => {
        Options.push({ value: val.io_name })
      })
    }
    return Options;
  }

  const getIndependentDirectorates = () => {
    const Options = [];
    if (departmentInfo && departmentInfo.id_directorates && departmentInfo.id_directorates.length > 0) {
      departmentInfo.id_directorates.map((val, index) => {
        Options.push({ value: val.id_name })
      })
    }
    return Options;
  }

  const onFinish = values => {
    // console.log('Received values of form:', values);
  };

  const stepsWizard = ({ step, push }) => {
    // console.log(step.id)

    //const name = this.formRef.current.getFieldValue("productName");
    //console.log("All field values", formRef.current.getFieldsValue());
    //push();
    switch (step.id) {
      case 'processdetail': {
        if (formRef.current) {
          formRef.current
            .validateFields()
            .then(() => {
              // Validation is successful
              setProcessDetails(formRef.current.getFieldsValue());
              localStorage.setItem('processDetailsDraft', JSON.stringify(formRef.current.getFieldsValue()));
              push();

            })
            .catch((errors) => {
              // Errors in the fields
            });
        }
        break;
      }
      case 'stages': {
        if (formStageRef.current) {
          formStageRef.current
            .validateFields()
            .then(() => {
              setStageDetails(formStageRef.current.getFieldsValue());
              // Validation is successful
              push();
            })
            .catch((errors) => {
              // Errors in the fields
            });
        }
        break;
      }
      default:
        push();
    }

  }

  const handleProcessFinish = useCallback((values) => {
    // do your staff with values
    // console.log(values)
    let stages = [];


    let data = {
      processName: values.processName,
      processSubject: values.processSubject ? values.processSubject : '',
      draft: true,
      stage: []
    }
    setLoading(true);
    let dData = {
      udata: data,
      uid: templateId
    }
    dispatch(editTemplate(dData));
  }, []);


  const handleStagesFinish = useCallback((values) => {
    // do your staff with values
    // console.log(values)
    let stages = [];

    if (values.stage && values.stage.length) {
      values.stage.map((v, i) => {
        let users = [];
        if (v.users && v.users.length) {
          v.users.map((u, j) => {
            if (u !== undefined) {
              let user = {};
              let username = typeof u.username != "undefined" ? JSON.parse(u.username) : null;
              if (u.template_uuid) {
                if (username) {
                  user = { username: username ? username.value : null, responseTime: { time: u.responseTime ? u.responseTime : '00:00:02:00' }, template_uuid: u.template_uuid, stage_uuid: u.stage_uuid, uuid: u.uuid };
                  users.push(user);
                }

              }
              else {
                if (username) {
                  user = { username: username ? username.value : null, responseTime: { time: u.responseTime ? u.responseTime : '00:00:02:00' } };
                  users.push(user);
                }
              }

              //let user = {username:u.username,responseTime:{time:u.responseTime}};

            }
            // let user = {};
            // let username = JSON.parse(u.username);
            // if(u.template_uuid){
            //   user = {username:username.value,responseTime:{time:u.responseTime},template_uuid:u.template_uuid,stage_uuid:u.stage_uuid,uuid:u.uuid};
            // }
            // else{
            //  user = {username:username.value,responseTime:{time:u.responseTime}};
            // }

            //  //let user = {username:u.username,responseTime:{time:u.responseTime}};
            //  users.push(user);
          })
        }
        let stage = {};
        if (v.template_uuid) {
          stage = { department: 'Chief of Air Staff', departmentType: v.departmentType, departmentTypeName: v.departmentTypeName, directorateWithinBranch: v.directorateWithinBranch ? v.directorateWithinBranch : '', template_uuid: v.template_uuid, uuid: v.uuid, users: users }
        }
        else {
          stage = { department: 'Chief of Air Staff', departmentType: v.departmentType, departmentTypeName: v.departmentTypeName, directorateWithinBranch: v.directorateWithinBranch ? v.directorateWithinBranch : '', users: users }
        }
        // let stage = {department:'Chief of Air Staff',departmentType:v.departmentType,departmentTypeName:v.departmentTypeName,directorateWithinBranch:v.directorateWithinBranch?v.directorateWithinBranch:'',users:users}
        stages.push(stage);
      })
    }

    let processdetails = JSON.parse(localStorage.getItem('processDetailsDraft'));
    let tdata = {
      processName: processdetails.processName,
      processSubject: processdetails.processSubject ? processdetails.processSubject : '',
      draft: true,
      stage: stages
    }

    // console.log(tdata)
    setLoading(true);
    let dData = {
      udata: tdata,
      uid: templateId
    }
    dispatch(editTemplate(dData));
  }, []);

  const setDepartmentType = (v, k) => {

    const fields = formStageRef.current.getFieldsValue();
    const { stage } = fields
    Object.assign(stage[k], { departmentTypeName: '', directorateWithinBranch: '' })
    formStageRef.current.setFieldsValue({ stage })
  }



  const getAppt = (dtype, department, k) => {
    let code = 'b';
    switch (department) {
      case 'Branch': {
        code = 'b';
        break;
      }
      case 'Independent Office': {
        code = 'io'
        break;
      }
      case 'Independent Directorate': {
        code = 'id'
        break;
      }
      default:
        code = 'b';
    }

    let Options = [];
    window.uOptions = null;
    try {
      fetch(process.env.REACT_APP_API_URL + "/api/template/getAppt?department=Chief of Air Staff&code=" + code + "&departmentTypeName=" + dtype, {
        method: 'get',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        }
      })
        .then(x => x.json())
        .then(data => apptOptions = data);

    } catch (error) {

    }

    if (apptOptions && apptOptions.data && apptOptions.data.length > 0) {
      apptOptions.data.map((val, index) => {
        Options.push({ label: val.name, value: val.username })
      })
    }
    return Options;
  }


  const saveProcessFormAsDraft = () => {
    let stages = [];

    if (stageDetails.stage && stageDetails.stage.length) {
      stageDetails.stage.map((v, i) => {
        let users = [];
        if (v.users && v.users.length) {
          v.users.map((u, j) => {
            if (u !== undefined) {
              let user = {};
              let username = typeof u.username != "undefined" ? JSON.parse(u.username) : null;
              if (u.template_uuid) {
                if (username) {
                  user = { username: username ? username.value : null, responseTime: { time: u.responseTime ? u.responseTime : '00:00:02:00' }, template_uuid: u.template_uuid, stage_uuid: u.stage_uuid, uuid: u.uuid };
                  users.push(user);
                }

              }
              else {
                if (username) {
                  user = { username: username ? username.value : null, responseTime: { time: u.responseTime ? u.responseTime : '00:00:02:00' } };
                  users.push(user);
                }
              }

              //let user = {username:u.username,responseTime:{time:u.responseTime}};

            }
            // let user;
            // let username = JSON.parse(u.username);
            // if(u.template_uuid){
            //   user = {username:username.value,responseTime:{time:u.responseTime},template_uuid:u.template_uuid,stage_uuid:u.stage_uuid,uuid:u.uuid};
            // }
            // else{
            //  user = {username:username.value,responseTime:{time:u.responseTime}};
            // }
            // // let user = {username:u.username,responseTime:{time:u.responseTime}};
            //  users.push(user);
          })
        }
        let stage;
        if (v.template_uuid) {
          stage = { department: 'Chief of Air Staff', departmentType: v.departmentType, departmentTypeName: v.departmentTypeName, directorateWithinBranch: v.directorateWithinBranch ? v.directorateWithinBranch : '', template_uuid: v.template_uuid, uuid: v.uuid, users: users }
        }
        else {
          stage = { department: 'Chief of Air Staff', departmentType: v.departmentType, departmentTypeName: v.departmentTypeName, directorateWithinBranch: v.directorateWithinBranch ? v.directorateWithinBranch : '', users: users }
        }
        //let stage = {department:'Chief of Air Staff',departmentType:v.departmentType,departmentTypeName:v.departmentTypeName,directorateWithinBranch:v.directorateWithinBranch?v.directorateWithinBranch:'',users:users}
        stages.push(stage);
      })
    }

    let processdetails = JSON.parse(localStorage.getItem('processDetailsDraft'));
    let data = {
      processName: processdetails.processName,
      processSubject: processdetails.processSubject ? processdetails.processSubject : '',
      draft: true,
      stage: stages
    }
    setLoading(true);
    let dData = {
      udata: data,
      uid: templateId
    }
    dispatch(editTemplate(dData));
  }

  const saveProcessForm = () => {
    let stages = [];

    if (stageDetails.stage && stageDetails.stage.length) {
      stageDetails.stage.map((v, i) => {
        let users = [];
        if (v.users && v.users.length) {
          v.users.map((u, j) => {
            if (u !== undefined) {
              let user = {};
              let username = typeof u.username != "undefined" ? JSON.parse(u.username) : null;
              if (u.template_uuid) {
                if (username) {
                  user = { username: username ? username.value : null, responseTime: { time: u.responseTime ? u.responseTime : '00:00:02:00' }, template_uuid: u.template_uuid, stage_uuid: u.stage_uuid, uuid: u.uuid };
                  users.push(user);
                }

              }
              else {
                if (username) {
                  user = { username: username ? username.value : null, responseTime: { time: u.responseTime ? u.responseTime : '00:00:02:00' } };
                  users.push(user);
                }
              }

              //let user = {username:u.username,responseTime:{time:u.responseTime}};

            }
            // let user;
            // let username = JSON.parse(u.username);
            //  if(u.template_uuid){
            //    user = {username:username.value,responseTime:{time:u.responseTime},template_uuid:u.template_uuid,stage_uuid:u.stage_uuid,uuid:u.uuid};
            //  }
            //  else{
            //   user = {username:username.value,responseTime:{time:u.responseTime}};
            //  }

            //  users.push(user);
          })
        }
        let stage;
        if (v.template_uuid) {
          stage = { department: 'Chief of Air Staff', departmentType: v.departmentType, departmentTypeName: v.departmentTypeName, directorateWithinBranch: v.directorateWithinBranch ? v.directorateWithinBranch : '', template_uuid: v.template_uuid, uuid: v.uuid, users: users }
        }
        else {
          stage = { department: 'Chief of Air Staff', departmentType: v.departmentType, departmentTypeName: v.departmentTypeName, directorateWithinBranch: v.directorateWithinBranch ? v.directorateWithinBranch : '', users: users }
        }

        stages.push(stage);
      })
    }

    // let processdetails = JSON.parse(localStorage.getItem('processDetails'));
    let processdetails = JSON.parse(localStorage.getItem('processDetailsDraft'));
    let data = {
      processName: processdetails.processName,
      processSubject: processdetails.processSubject,
      draft: false,
      stage: stages
    }
    let dData = {
      udata: data,
      uid: templateId
    }
    // console.log(data)
    setLoading(true);
    dispatch(editTemplate(dData));
  }

  return (
    <>
      <Container>
        <Breadcrumb style={{ margin: '16px 0', paddingLeft: 50, marginBottom: 0 }} separator=">">
          <Breadcrumb.Item><Link to="/manage-seen-stamp">Manage Seen Stamp</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Edit Draft Seen Stamp</Breadcrumb.Item>
        </Breadcrumb>

        <div className="site-layout-content" style={{ marginTop: 0, paddingTop: 0 }}>

          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%', position: 'fixed', zIndex: 1, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }

            <Wizard onNext={stepsWizard}>
              <Steps>
                <Step
                  id="processdetail"
                  render={({ next, previous, step, steps }) => (
                    <div style={{ backgroundColor: '#ffffff' }}>
                      <Row style={{ paddingTop: 35, paddingBottom: 20, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
                        <Col span="6"></Col>
                        <Col span="9" >
                          <h1 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 24 }}>Seen Stamp Details</h1>
                        </Col>
                        <Col span="9" style={{ paddingLeft: 25 }}>
                          <Button type="primary" shape="round" size="small" style={{ fontWeight: 'bold' }}>STEP 1/3</Button>
                        </Col>
                      </Row>
                      <Form
                        ref={formRef}
                        layout="vertical"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        onFinish={handleProcessFinish}
                        className="seen-stamp-form-custom"
                      >
                        <Row style={{ paddingTop: 24, paddingBottom: 100, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 10 }}>
                          {/* <Col span="6"></Col> */}
                          <Col span={11} offset={6} className="seen-stamp-form-custom-col">
                            {/* <Form
                              layout="vertical"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 15}}
                              
                              > */}
                            <Form.Item
                              name={'processName'}
                              rules={[{ required: true, message: 'Seen stamp name is required' }]}
                              requiredMark={'optional'}
                              label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Seen Stamp Name*</p>}  >
                              <Input className="formInput" placeholder="" />
                            </Form.Item>
                            <Form.Item
                              name={'processSubject'}
                              label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Seen Stamp Description</p>}
                            >
                              <Input type="text" className="formInput" placeholder="" minlength="5" maxlength="180" size="10" />
                            </Form.Item>
                            {/* </Form> */}
                          </Col>
                        </Row>
                        {/* <Card title="Process Details" extra={<a href="#">More</a>} style={{ border: '1px solid #dfe0eb' }}>
        <p>Card content</p>
        <p>Card content</p>
        <p>Card content</p>
        </Card> */}
                        <Row style={{ paddingTop: 24, paddingBottom: 24, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 10 }}>
                          <Col span="6"></Col>
                          <Col span="11" style={{ textAlign: 'right', marginLeft: 12 }}>
                            <Space>
                              <Link to={'/all-seen-stamp'}><Button type="primary" size="large" ghost>Cancel</Button></Link>
                              <Button type="primary" size="large" htmlType="submit">Save as Draft</Button>
                              <Button type="primary" size="large" onClick={next}>Next</Button>
                            </Space>
                          </Col>
                          <Col span="6"></Col>

                        </Row>
                      </Form>
                    </div>
                  )}
                />
                <Step
                  id="stages"
                  render={({ next, previous, step, steps }) => (
                    <div style={{ backgroundColor: '#ffffff' }}>
                      <Row style={{ paddingTop: 35, paddingBottom: 20, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
                        <Col span="6"></Col>
                        <Col span="9" >
                          <h1 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 24 }}>Define Roles and Appointment</h1>
                        </Col>
                        <Col span="9" style={{ paddingLeft: 25 }}>
                          <Button type="primary" shape="round" size="small" style={{ fontWeight: 'bold' }}>STEP 2/3</Button>
                        </Col>
                      </Row>
                      <Form
                        layout="vertical"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        ref={formStageRef}
                        onFinish={handleStagesFinish}
                        className="seen-stamp-form-custom-step"
                      >
                        <Row style={{ paddingTop: 24, paddingBottom: 135, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 10 }}>
                          {/* <Col span="6"></Col> */}
                          <Col span={11} offset={6} className="seen-stamp-form-custom-step-col">
                            {/* <Form
                              layout="vertical"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 15}}
                              ref={formStageRef}
                              onFinish={handleStagesFinish}
                              
                              > */}
                            <Form.List name="stage" initialValue={stagesValue}>
                              {(fields, { add, remove }) => (
                                <>

                                  {fields.map(({ key, name, fieldKey, ...restField }) => (
                                    <>
                                      <Form.Item className="seen-stamp-form-custom-step-count">
                                        <Col span={6} style={{ textAlign: 'center' }}>
                                          <h2 style={{ fontWeight: '400', fontStyle: 'normal', padding: '10px', fontSize: 20, marginBottom: 0 }}>Stage #{key + 1} </h2>
                                        </Col>
                                        <Col span={18}>

                                        </Col>

                                      </Form.Item>

                                      <Form.Item
                                        hidden={true}
                                        name={[name, 'template_uuid']}
                                      >
                                        <Input type="hidden" />
                                      </Form.Item>

                                      <Form.Item
                                        hidden={true}
                                        name={[name, 'uuid']}
                                      >
                                        <Input type="hidden" />
                                      </Form.Item>

                                      <div className="seen-stamp-form-custom-step-item">
                                        <Form.Item
                                          name={[name, 'departmentType']}
                                          //name={'departmentType'} 
                                          rules={[{ required: true, message: 'Department Type  is required' }]}
                                          requiredMark={'optional'}
                                          style={{ marginRight: 10 }}
                                          label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Select Type*</p>}
                                        //initialValue={'Branch'}
                                        >
                                          {/* <Input className="formInput" placeholder="" /> */}
                                          <Select style={{ marginBottom: 20 }} onChange={(v) => setDepartmentType(v, key)} >
                                            <Select.Option value="Branch">Branch</Select.Option>
                                            <Select.Option value="Independent Office">Independent Office</Select.Option>
                                            <Select.Option value="Independent Directorate">Independent Directorate</Select.Option>
                                          </Select>
                                        </Form.Item>


                                        <Form.Item style={{ marginBottom: 0 }}>
                                          <Form.Item
                                            {...restField}
                                            //label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}></p>}
                                            shouldUpdate={(prevValues, currentValues) => prevValues.stage[key] && prevValues.stage[key].departmentType !== currentValues.stage[key].departmentType}
                                          >
                                            {({ getFieldValue }) =>
                                              getFieldValue('stage')[key] ?
                                                getFieldValue('stage')[key].departmentType == 'Branch' ? (
                                                  <>
                                                    <Form.Item
                                                      // name={"departmentTypeName"}
                                                      {...restField}
                                                      name={[name, 'departmentTypeName']}
                                                      className={'stage2FormItem'}
                                                      rules={[{ required: true, message: 'Branch is required' }]}
                                                      requiredMark={'optional'}
                                                      style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Select Branch*</p>}
                                                    //initialValue={state['departmentType_'+key]}
                                                    // shouldUpdate={(prevValues, currentValues) => prevValues.stage[key] && prevValues.stage[key].b_directorate !==currentValues.stage[key].departmentType}
                                                    >
                                                      <Select value={null} options={getBranches()} defaultActiveFirstOption={false} onChange={(v) => setUsers(v, key, getFieldValue('stage')[key].departmentType, name)} allowClear>
                                                        {/* <Select.Option value="demo">Demo</Select.Option> */}
                                                      </Select>
                                                    </Form.Item>

                                                    <Form.Item
                                                      {...restField}
                                                      //style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                                      // style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '-29px 8px' }}
                                                      style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                                      //label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}></p>}
                                                      shouldUpdate={(prevValues, currentValues) => prevValues.stage[key] && prevValues.stage[key].departmentTypeName !== currentValues.stage[key].departmentTypeName}
                                                    >
                                                      {({ getFieldValue }) =>
                                                        getFieldValue('stage')[key] ?
                                                          getFieldValue('stage')[key].departmentTypeName !== '' ? (
                                                            <>
                                                              <Form.Item
                                                                {...restField}
                                                                name={[name, 'directorateWithinBranch']}
                                                                // rules={[{ required: true, message: 'Directorate is required' }]}
                                                                // requiredMark={'optional'}
                                                                className={'stage2FormItem'}
                                                                //  style={{ display: 'inline-block', width: '100% !important', margin: '-29px 8px' }}
                                                                // style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                                                label={<Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Directorate*</p></Col><Col style={{ textAlign: 'right' }} span={6}></Col></Row>}

                                                              >
                                                                <Select value={null} style={{ width: '100%' }} options={getDirectorate(getFieldValue('stage')[key].departmentTypeName)} defaultActiveFirstOption={false} allowClear>
                                                                  {/* <Select.Option value="demo">Demo</Select.Option> */}
                                                                </Select>
                                                              </Form.Item>

                                                            </>
                                                          ) : <Form.Item
                                                            name={[name, 'directorateWithinBranch']}
                                                            // rules={[{ required: true, message: 'Directorate is required' }]}
                                                            // requiredMark={'optional'}
                                                            className={'stage2FormItem'}
                                                            // style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                                            label={<Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Directorate*</p></Col><Col style={{ textAlign: 'right' }} span={6}></Col></Row>}

                                                          >
                                                            <Select >
                                                              <Select.Option value="">No records found</Select.Option>
                                                            </Select>
                                                          </Form.Item> : null}
                                                    </Form.Item>


                                                  </>
                                                ) : getFieldValue('stage')[key].departmentType == 'Independent Office' ? (
                                                  <>
                                                    <Form.Item
                                                      // name={"departmentTypeName"}
                                                      name={[name, 'departmentTypeName']}
                                                      className={'stage2FormItem'}
                                                      rules={[{ required: true, message: 'Independent office is required' }]}
                                                      requiredMark={'optional'}
                                                      label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Select Independent Office*</p>}
                                                    >
                                                      <Select options={getIndependentOffices()} defaultActiveFirstOption={true} onChange={(v) => setUsers(v, key, getFieldValue('stage')[key].departmentType, name)} allowClear>
                                                      </Select>
                                                    </Form.Item>
                                                  </>
                                                ) : getFieldValue('stage')[key].departmentType == 'Independent Directorate' ? (
                                                  <>
                                                    <Form.Item
                                                      // name={"departmentTypeName"}
                                                      name={[name, 'departmentTypeName']}
                                                      className={'stage2FormItem'}
                                                      rules={[{ required: true, message: 'Independent directorate is required' }]}
                                                      requiredMark={'optional'}
                                                      label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Select Independent Directorate*</p>}
                                                    >
                                                      <Select options={getIndependentDirectorates()} defaultActiveFirstOption={true} onChange={(v) => setUsers(v, key, getFieldValue('stage')[key].departmentType, name)} allowClear>
                                                      </Select>
                                                    </Form.Item>
                                                  </>
                                                ) : null
                                                : null
                                            }

                                          </Form.Item>
                                        </Form.Item>

                                        {/* <Form.Item 
                                            name={[name,'userlist']} >
                                              <Input  type={'hidden'} />
                                            </Form.Item> */}

                                        <Form.List name={[name, 'users']} initialValue={[{ username: '', responseTime: '' }]}>

                                          {(users, { add, remove }) => (
                                            <>

                                              <Form.Item >
                                                <Row style={{ width: '100%' }}>
                                                  <Col span={18}>
                                                    <h2 style={{ fontWeight: '400', fontStyle: 'normal', fontSize: 20 }}>APPT </h2>
                                                  </Col>
                                                  <Col style={{ textAlign: 'right' }} span={6}>
                                                    <Button onClick={() => add()} style={{ marginBottom: -2, marginTop: -5, marginRight: 10, padding: 0, fontSize: 18, fontWeight: 500 }} type="link">+ ADD</Button>
                                                  </Col>
                                                </Row>
                                              </Form.Item>



                                              {/* {users.map(({ key, uname, fieldKey, ...brestField }) => ( */}
                                              {users.map((user, k) => (
                                                <Form.Item style={{ marginBottom: 0 }}>

                                                  <Form.Item
                                                    hidden={true}
                                                    name={[name, 'uuid']}
                                                  >
                                                    <Input type="hidden" />
                                                  </Form.Item>

                                                  <Form.Item
                                                    hidden={true}
                                                    name={[name, 'stage_uuid']}
                                                  >
                                                    <Input type="hidden" />
                                                  </Form.Item>

                                                  <Form.Item
                                                    hidden={true}
                                                    name={[name, 'template_uuid']}
                                                  >
                                                    <Input type="hidden" />
                                                  </Form.Item>

                                                  <Form.Item
                                                    // {...brestField}
                                                    // style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} 
                                                    //label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}></p>}
                                                    shouldUpdate={(prevValues, currentValues) => prevValues.stage[key] && prevValues.stage[key].departmentTypeName !== currentValues.stage[key].departmentTypeName}
                                                  >
                                                    {({ getFieldValue }) =>
                                                      getFieldValue('stage')[key] ?
                                                        getFieldValue('stage')[key].departmentTypeName != '' ? (
                                                          <>
                                                            <Form.Item
                                                              {...user}
                                                              name={[user.name, 'username']}
                                                              rules={[{ required: true, message: 'Plese select user' }]}
                                                              requiredMark={'optional'}
                                                              className={'stage2FormItem'}
                                                              // style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} 
                                                              label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>APPT 1*</p>}  >
                                                              {/* <Select value={null} options={getAppt(getFieldValue('stage')[key].departmentTypeName,getFieldValue('stage')[key].departmentType,key)} allowClear> */}
                                                              {/* <Select  value={null} options={getFieldValue('stage')[key].userlist} allowClear> */}
                                                              <Select options={state['userlist__dep_' + name]} allowClear>
                                                                {/* <Select allowClear>
                                                                    {state['userlist__dep_'+name] &&
                                                                    state['userlist__dep_'+name].map((ul,u) => {
                                                                      return (
                                                                        <Select.Option value={u.username}>{ul.name}</Select.Option>
                                                                      )
                                                                    })
                                                                    } */}
                                                                {/* <Select.Option value="demo">Demo</Select.Option> */}
                                                              </Select>

                                                            </Form.Item>
                                                          </>
                                                        ) : <Form.Item
                                                          {...user}
                                                          name={[user.name, 'username']}
                                                          rules={[{ required: true, message: 'Plese select user' }]}
                                                          requiredMark={'optional'}
                                                          className={'stage2FormItem'}
                                                          // style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} 
                                                          label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>APPT 1*</p>}  >
                                                          <Select value={null} >
                                                            <Select.Option value="">No records found</Select.Option>
                                                          </Select>
                                                        </Form.Item> : <Form.Item
                                                          {...user}
                                                          name={[user.name, 'username']}
                                                          rules={[{ required: true, message: 'Plese select user' }]}
                                                          requiredMark={'optional'}
                                                          className={'stage2FormItem'}
                                                          // style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} 
                                                          label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>APPT 1*</p>}  >
                                                          <Select value={null}  >
                                                            <Select.Option value="">No records found</Select.Option>
                                                          </Select>
                                                        </Form.Item>}
                                                  </Form.Item>

                                                  <Form.Item
                                                    {...user}
                                                    name={[user.name, 'responseTime']}
                                                    hidden={true}
                                                    initialValue={'00:00:02:00'}
                                                  >
                                                    <Input type="text" value={'00:00:02:00'} />
                                                    {/* <MaskedInput style={{ height: 43 }} className="formInput" mask="11:11:11:11" placeholder="DD:HH:MM:SS" /> */}
                                                  </Form.Item>

                                                  {/* <Form.Item
                                                    {...user}
                                                    name={[user.name,'responseTime']}
                                                    //rules={[{ required: true, message: 'Response time is required' }]}
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: 'Response time is required!',
                                                      },
                                                      // { max: 15, message: 'Username can have a maximum length of 15' },
                                                      {
                                                          // pattern: new RegExp('^[0-9]{1,15}$'),
                                                          // pattern: new RegExp('^[0-9]+$'),
                                                          //pattern: new RegExp('^\(?+[0-9]{2}(\-|\))-[0-9]{3}-[0-9]{4}-[0-9]{3}$'),
                                                          pattern: new RegExp('^[0-9]{2}:[0-9]{2}:[0-9]{2}:[0-9]{2}$'),
                                                          message: 'Response time is invalid'
                                                      }
                                                    ]}
                                                    requiredMark={'optional'}
                                                    className={'stage2FormItem'}
                                                    style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                                      label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Response Time*</p></Col><Col style={{textAlign:'right'}} span={6}></Col></Row>}
                                                    >
                                                  
                                                    <MaskedInput style={{height:43}} className="formInput"  mask="11:11:11:11"  placeholder="DD:HH:MM:SS" />
                                                    </Form.Item> */}

                                                </Form.Item>
                                              ))}
                                            </>
                                          )}

                                        </Form.List>
                                      </div>

                                    </>
                                  ))}
                                  <Form.Item style={{ marginTop: 25 }} >
                                    <Row style={{ width: '100%' }}>
                                      <Col style={{ textAlign: 'left' }} span={24}>
                                        <Button onClick={() => add()} style={{ marginBottom: -2, marginTop: -5, padding: 0, fontSize: 18, fontWeight: 500, borderBottom: '1px solid #3e57ff' }} type="link">+ ADD Another Stage</Button>
                                      </Col>
                                    </Row>
                                  </Form.Item>


                                </>
                              )}
                            </Form.List>

                            {/* </Form> */}
                          </Col>
                        </Row>

                        <Row style={{ paddingTop: 24, paddingBottom: 24, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 10 }}>
                          <Col span="6"></Col>
                          <Col span="11" style={{ textAlign: 'right', marginLeft: 12 }}>
                            <Button type="primary" size="large" onClick={previous} style={{ float: 'left' }} ghost>Back</Button>
                            <Space>
                              <Button type="primary" size="large" htmlType="submit" >Save as Draft</Button>
                              <Button type="primary" size="large" onClick={next}>Next</Button>
                            </Space>
                          </Col>
                          <Col span="6"></Col>

                        </Row>
                      </Form>

                    </div>
                  )}
                />
                <Step
                  id="templatedetails"
                  render={({ next, previous, step, steps }) => (
                    <div style={{ backgroundColor: '#ffffff' }}>
                      <Row style={{ paddingTop: 35, paddingBottom: 20, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
                        <Col span="6"></Col>
                        <Col span="11" >
                          <h1 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 24 }}>Seen Stamp Preview</h1>
                        </Col>
                        <Col span="5" style={{ paddingLeft: 25 }}>
                          <Button type="primary" shape="round" size="small" style={{ fontWeight: 'bold' }}>STEP 3/3</Button>
                        </Col>
                      </Row>

                      <Row style={{ paddingTop: 10, paddingBottom: 80, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 0 }}>
                        <Col span={24}>
                          <Row style={{ paddingTop: 15, paddingBottom: 0 }}>
                            <Col span="6"></Col>
                            <Col span={18}><h2 style={{ color: '#000000', fontSize: '16px' }}>Seen Stamp Details</h2></Col>
                          </Row>
                        </Col>
                        {/* <Col span="7"></Col>
                        <Col span="17"  > */}
                        <Col span="24">
                          <Form
                            layout="vertical"
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            className="new-template-process-detail-box"
                          >
                            <Form.Item label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Seen Stamp Name*</p>}  >
                              {/* <Input className="formInput" placeholder="" /> */}
                              <h3>{processDetails && processDetails.processName}</h3>
                            </Form.Item>
                            <Form.Item
                              label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 0 }}>Seen Stamp Description</p>}
                            >
                              <h3>{processDetails && processDetails.processSubject}
                              </h3>
                            </Form.Item>
                            {/* <Form.Item label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,width:'100%'}}>Do you want to seen stamp for this process?</p>}  >
               
                <h3>Yes</h3>
              </Form.Item> */}
                          </Form>
                        </Col>
                        <Col span={24}>
                          <Row style={{ paddingTop: 30, paddingBottom: 0 }}>
                            <Col span="6"></Col>
                            <Col span={18}><h2 style={{ color: '#000000', fontSize: '16px' }}>Define Roles and Appointment</h2></Col>
                          </Row>
                        </Col>
                        {/* <Col span={7}></Col> */}
                        <Col span={24}>
                          <Form
                            layout="vertical"
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}

                          >
                            <>
                              {stageDetails.stage && stageDetails.stage.length &&
                                <>
                                  {stageDetails.stage.map((v, i) => {
                                    return (
                                      <div className="new-template-process-detail-box" style={{ marginBottom: 20 }}>
                                        <Form.Item >
                                          <Col span={6} style={{ textAlign: 'center' }}>
                                            <h2 style={{ fontWeight: '400', fontStyle: 'normal', fontSize: 20, marginBottom: 0, color: "#ffffff", padding: '7px 10px', background: '#138AE6', borderRadius: '5px' }}>Stage #{i + 1} </h2>
                                          </Col>
                                          <Col span={18}>

                                          </Col>

                                        </Form.Item>
                                        <Form.Item style={{ marginBottom: 0 }}>

                                          {/* <Form.Item 
              className={'stage2FormItem'}
              style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0}}>Select Department*</p>}  >
             
                <h3>CCIS</h3>
              </Form.Item> */}

                                          <Form.Item
                                            className={'stage2FormItem'}
                                            style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0px' }}
                                            label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Type*</p>}
                                          >
                                            {/* <Input className="formInput" placeholder="" /> */}
                                            <h3>{v.departmentType}</h3>
                                          </Form.Item>

                                        </Form.Item>

                                        <Form.Item style={{ marginBottom: 0 }}>
                                          <Form.Item
                                            className={'stage2FormItem'}
                                            style={{ display: 'inline-block', width: v.departmentType == 'Branch' ? 'calc(50% - 8px)' : '80%' }} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Select {v.departmentType}*</p>}  >
                                            <h3>{v.departmentTypeName}</h3>
                                          </Form.Item>


                                          {v.departmentType == 'Branch' &&
                                            <Form.Item
                                              className={'stage2FormItem'}
                                              style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                              label={<Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Directorate*</p></Col><Col style={{ textAlign: 'right' }} span={6}></Col></Row>}
                                            >
                                              <h3>{v.directorateWithinBranch}</h3>
                                            </Form.Item>
                                          }


                                        </Form.Item>

                                        <>
                                          {v.users && v.users.length &&
                                            <>
                                              {v.users.map((u, j) => {
                                                let responseTime = u.responseTime ? u.responseTime.split(":") : [];
                                                let username = JSON.parse(u.username);
                                                return (
                                                  <>
                                                    <Form.Item style={{ marginBottom: 0 }}>
                                                      <Form.Item
                                                        className={'stage2FormItem'}
                                                        //style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} 
                                                        label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>APPT 1*</p>}  >
                                                        {/* <h3>Mark Joe (Officer)</h3> */}
                                                        <h3>{username.label} </h3>
                                                      </Form.Item>

                                                      {/* <Form.Item
                                                          className={'stage2FormItem'}
                                                          style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                                            label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Response Time*</p></Col><Col style={{textAlign:'right'}} span={6}></Col></Row>}
                                                          >
                                                          <h3>{responseTime[0] && responseTime[0] > 1 ? responseTime[0]+' Days':responseTime[0]+' Day'} {responseTime[1] && responseTime[1] > 1 ? responseTime[1]+' Hrs':responseTime[1]+' Hr'} {responseTime[2] && responseTime[2] > 1 ? responseTime[2]+' Min':responseTime[2]+' Min'} {responseTime[3] && responseTime[3] > 1 ? responseTime[3]+' Sec':responseTime[0]+' Sec'}</h3>
                                                          </Form.Item> */}

                                                    </Form.Item>
                                                  </>
                                                )
                                              })}
                                            </>
                                          }

                                        </>

                                      </div>
                                    )
                                  })
                                  }
                                </>
                              }

                            </>
                          </Form>
                        </Col>
                      </Row>
                      {/* <Card title="Process Details" extra={<a href="#">More</a>} style={{ border: '1px solid #dfe0eb' }}>
        <p>Card content</p>
        <p>Card content</p>
        <p>Card content</p>
        </Card> */}
                      <Row style={{ paddingTop: 24, paddingBottom: 24, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 10 }}>
                        <Col span="6"></Col>
                        <Col span="13" style={{ textAlign: 'right', marginLeft: 0 }}>
                          <Button type="primary" size="large" onClick={previous} style={{ float: 'left' }} ghost>Back</Button>
                          <Space>
                            {/* <Button type="primary" size="large" onClick={previous}  ghost>Back</Button> */}
                            <Button type="primary" size="large" onClick={() => saveProcessFormAsDraft()}>Save as Draft</Button>
                            <Button type="primary" size="large" onClick={() => saveProcessForm()}>Submit</Button>
                          </Space>
                        </Col>
                        <Col span="5"></Col>

                      </Row>
                      {/* <Row  style={{paddingTop:24,paddingBottom:24,borderLeft:'1px solid #dfe0eb',borderRight:'1px solid #dfe0eb',borderBottom:'1px solid #dfe0eb',marginBottom:10}}>
         <Col span="6"></Col>
         <Col span="11" style={{textAlign:'right',marginLeft:12}}>
         <Space>
       <Button type="primary" size="large" ghost>Cancel</Button>
         <Button type="primary" size="large" >Save as Draft</Button>
         <Button type="primary" size="large" onClick={next}>Next</Button>
       </Space>
         </Col>
         <Col span="6"></Col>
         
         </Row> */}

                    </div>
                  )}
                />
              </Steps>
            </Wizard>

          </div>

        </div>
      </Container>
    </>
  );
}
